import AddEditPropertyForm from "./properties/AddEditPropertyForm";
import { Box } from "@mantine/core";
import AddEditMeterForm from "./meters/AddEditMeterForm";
import AddEditClientForm from "./clients/AddEditClientForm";
import { REGISTRATION_SIDEBAR_SELECTOR } from "../../constants";
import { useRegisterStore } from "../../store/register.store";

export default function RegistrationAsideBarView() {
  const registrationSidebarSelectorStateValue = useRegisterStore(
    (state) => state.registrationSidebarSelectorState
  );

  return (
    <Box>
      {registrationSidebarSelectorStateValue ===
        REGISTRATION_SIDEBAR_SELECTOR.propertyRegistration && (
        <AddEditPropertyForm />
      )}
      {registrationSidebarSelectorStateValue ===
        REGISTRATION_SIDEBAR_SELECTOR.meterRegistration && <AddEditMeterForm />}
      {registrationSidebarSelectorStateValue ===
        REGISTRATION_SIDEBAR_SELECTOR.clientRegistration && (
        <AddEditClientForm />
      )}
    </Box>
  );
}
